import dayjs from "dayjs";

import { REPORT_RANGES, navLinks } from "./constants";

export const getReportRangeFromPathname = (pathname = "") => {
  const normalizedPath = pathname.toLowerCase();

  if (normalizedPath.startsWith("/annual/")) return REPORT_RANGES.YEAR;
  if (normalizedPath.startsWith("/monthly/")) return REPORT_RANGES.MONTH;
  if (normalizedPath.startsWith("/weekly/")) return REPORT_RANGES.WEEK;
  if (normalizedPath.startsWith("/daily/")) return REPORT_RANGES.DAY;
  if (normalizedPath.startsWith("/realtime/")) return REPORT_RANGES.RT;
  if (normalizedPath.startsWith("/ticket-info/")) return REPORT_RANGES.TICKET_INFO;

  return null;
};

export const getDefaultReportLinkForRange = (reportRange) =>
  navLinks.find((a) => a.name === reportRange)?.links[0]?.links[0]?.link || "/";

export const getDefaultDateRangeForReportRange = (reportRange) => {
  switch (reportRange) {
    case REPORT_RANGES.YEAR:
      return [
        dayjs().subtract(1, "year").startOf("year").unix(),
        dayjs().subtract(1, "year").endOf("year").unix(),
      ];
    case REPORT_RANGES.MONTH:
      return [
        dayjs().subtract(1, "month").startOf("month").unix(),
        dayjs().subtract(1, "month").endOf("month").unix(),
      ];
    case REPORT_RANGES.WEEK:
      return [
        dayjs().subtract(1, "week").startOf("week").unix(),
        dayjs().subtract(1, "week").endOf("week").unix(),
      ];
    case REPORT_RANGES.DAY:
    case REPORT_RANGES.TICKET_INFO:
      return [
        dayjs().subtract(1, "day").startOf("day").unix(),
        dayjs().subtract(1, "day").endOf("day").unix(),
      ];
    default:
      return [];
  }
};
